<div class="flex-row padding-top">
  <div class="flex-1"></div>

  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="form-content flex-1">
    <h1 class="center-text login-title">Customer Portal</h1>

    <h1 class="center-text login-sub-title">Login</h1>

    <mat-form-field appearance="outline">
      <mat-label>Email Address</mat-label>

      <input matInput type="text" formControlName="emailAddress">

      @if (formControls.emailAddress.hasError('required')) {
        <mat-error>Email is required.</mat-error>
      }

      @if (formControls.emailAddress.hasError('email')) {
        <mat-error>Email is invalid.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Password</mat-label>

      <input matInput type="password" formControlName="password">

      @if (formControls.password.hasError('required')) {
        <mat-error>Password is required.</mat-error>
      }
    </mat-form-field>

    @if (isLoginFailed) {
      <div class="red-text error-padding">
        {{errorMessage}}
      </div>
    }

    <div class="form-group">
      @if (!loading) {
        <button mat-raised-button style="border-radius: 4px" color="primary" type="submit" class="btn btn-primary span-form mb-2" [disabled]="loading || !loginForm.valid">
          Login
        </button>
      }

      @if (loading) {
        <mat-progress-bar style="height: 4px;" mode="indeterminate"></mat-progress-bar>
      }

      <a mat-raised-button style="border-radius: 4px" color="primary" routerLink="/forgot-password" routerLinkActive="forgot-password" class="btn btn-link span-form button-style mb-2">Forgot Password</a>

      <a mat-raised-button style="border-radius: 4px" color="primary" routerLink="/registration" routerLinkActive="register" class="btn btn-link span-form button-style">Register</a>
    </div>
  </form>

  <div class="flex-1"></div>
</div>